// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__2O8rN","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3fF9v"};